import { IconButton } from "@mui/material";
import { styled } from "@mui/styles";
import { FC } from "react";
import DownloadIcon from "@mui/icons-material/Download";

const DownloadButton = styled(IconButton)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  color: "#853EF8",
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

interface IListDownloadButton {
  href?: string;
}

const ListDownloadButton: FC<IListDownloadButton> = ({ href }) => {
  return (
    <a href={href} download rel="noopener noreferrer" target="_blank">
      <DownloadButton style={{ height: 30, width: 30 }}>
        <DownloadIcon style={{ height: 20, width: 20 }} />
      </DownloadButton>
    </a>
  );
};

export default ListDownloadButton;
